import { useEffect, useState } from "react";

// hooks
import { useStateOfMultiSelectFilter } from "@/hooks/useStateOfMultiSelectFilter";

// utils
import _concat from "lodash/concat";
import _filter from "lodash/filter";
import _size from "lodash/size";

// types
import MultiSelectFilter from "@tajawal/web-flights-sdk/lib/stores/filter/base/multi-select-filter.store";
import { FILTER_DUMMY_ANY_OPTION } from "@/constants/common.constants";
import { pushFilterChangeGtmEvent } from "@/utils/avoGtm.utils";
import { FILTER_MAP } from "@tajawal/web-flights-sdk/lib/constants/filters.constants";

function useAirlineFilter(filter: MultiSelectFilter) {
  const { state, toggle, isDirty, reset, params, isSelected } =
    useStateOfMultiSelectFilter(filter);
  const [airlineRadioState, setAirlineRadioState] = useState(
    isDirty ? undefined : FILTER_DUMMY_ANY_OPTION,
  );

  useEffect(() => {
    setAirlineRadioState(
      _size(params) > 0 ? undefined : FILTER_DUMMY_ANY_OPTION,
    );
  }, [params]);

  function handleToggleOption({ code, selected }) {
    const selectedAirlineFilters = _concat(
      _filter(params, (c) => c !== code),
      [selected ? "" : code],
    ).join(",");
    toggle([code], true);

    pushFilterChangeGtmEvent(
      FILTER_MAP.AIRLINE,
      JSON.stringify(selectedAirlineFilters),
    );

    const shouldReset = selected && _size(params) <= 2;
    setAirlineRadioState(shouldReset ? FILTER_DUMMY_ANY_OPTION : undefined);
  }

  function handleReset() {
    reset(true);
    setAirlineRadioState(FILTER_DUMMY_ANY_OPTION);
  }

  return {
    state,
    toggle,
    isDirty,
    reset,
    params,
    handleToggleOption,
    handleReset,
    airlineRadioState,
    isSelected,
  };
}

export default useAirlineFilter;
